import styled from "styled-components";

export const Message = styled.p`
    font-size: 16px;
    color: ${props => props.theme.palette.common.black};
`;